export const cardCancellation = {
    enabled: true,
    _description:
        'Enables the card cancellation feature at bank card settings page and card features page',
};
